import Header from '../../__Layout/Header';
import React  from "react";

export default function ContactUs() {
   
    return (
        <div className="Home">
            <Header />
            <main id="main" className="main">
            <div className="pagetitle">
            <h1>Contact Us</h1>
            <nav>
                <ol className="breadcrumb">
                <li className="breadcrumb-item"><a href="index.html">Home</a></li>
                <li className="breadcrumb-item active">Contact Us</li>
                </ol>
            </nav>
            </div>
            <section className="section ContactUs">
            <div className="row">
                <div className="col-lg-12">
                    <div className="row">
                        <div className="col-xxl-12 col-md-12">
                            <div className="card info-card sales-card">
                                <div className="card-body">
                                <h5 className="card-title">Contact Us</h5>
                                <div className="d-flex align-items-center">
                                    <div className="ps-3 table-responsive">
                                           <table className="table">   
                                                <tbody>
                                                    <tr>
                                                        <td>Address	</td> 
                                                        <td>P. O. Box 391404, 1805, opal Tower, Business Bay, Dubai, UAE</td> 
                                                    </tr>
                                                    <tr>
                                                        <td>Phone</td> 
                                                        <td ><a href="tel:+97144431124"> 00971-44431124</a></td> 
                                                    </tr>
                                                    <tr>
                                                        <td>Mobile</td> 
                                                        <td ><a href="tel:+971553557473">00971-553557473</a></td> 

                                                        <td></td> 
                                                    </tr>
                                                    <tr>
                                                        <td>Fax</td>                                      
                                                        <td ><a href="tel:+97144431128">00971-44431128</a></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Email</td> 
                                                        <td ><a href="mailto:info@qhseinternational.com">info@qhseinternational.com</a></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Website</td> 
                                                        <td ><a href="https://www.qhseinternational.com/" target="_blank">www.qhseinternational.com</a></td>

                                                        
                                                    </tr>
                                                    <tr>
                                                        <td>Facebook</td> 
                                                        <td ><a href="https://web.facebook.com/QHSEDubai/?_rdc=1&_rdr" target="_blank">QHSEDubai</a></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Twitter</td> 
                                                        <td ><a href="https://twitter.com/QHSEI" target="_blank">QHSEI</a></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Instagram</td> 
                                                        <td ><a href="https://www.instagram.com/qhse_international/" target="_blank">Qhse_international</a></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Youtube</td>
                                                        <td ><a href="https://www.youtube.com/channel/UCwBRvV88GxrdafUOtgK1alA" target="_blank">Youtube</a></td> 
                                                    </tr>
                                                    <tr>

                                                    <td>Linkedin</td> 
                                                    <td ><a href="https://www.linkedin.com/company/3575282/admin" target="_blank">Linkedin</a></td>

                                                    </tr>
                                                </tbody>
                                            </table> 
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            </section>

            
           </main>
        </div>
    );
}